import React from 'react'

import { Button, Portlet, Form, Row, Col, Divider, Table } from '_zari/core'

import * as Filtros from './filtros'
import * as Modals from './modals'

const tableHeaderRows = [
  { label: 'FECHA INGRESO', width: 120 },
  { label: 'TITULO' },
  { label: 'SERVICIO' },
  { label: 'SUB SERVICIO 1' },
  { label: 'SUB SERVICIO 2' },
  { label: 'PRODUCTO' },
  { label: 'CANTIDAD', width: 100 },
  { label: '', width: 100 }
]

const TIPOSFILTROS = {
  COSTO: '1',
  SERVICIO: '2'
}

const AnalisisDeReporte = () => {
  const [tipoFiltro, setTipoFiltro] = React.useState(TIPOSFILTROS.COSTO)

  const [mostrarTabla, setMostrarTabla] = React.useState(false)
  const [mostrarModalInformacion, setMostrarModalInformacion] = React.useState(false)

  const [idCentroCostoNivel2, setIdCentroCostoNivel2] = React.useState('')
  const [idServicio, setIdServicio] = React.useState('')
  const [idSubServicio1, setIdSubServicio1] = React.useState('')
  const [idSubServicio2, setIdSubServicio2] = React.useState('')

  const tableBaseParamsRef = React.useRef({})
  const idTallerModalRef = React.useRef('')
  const idKardexModalRef = React.useRef('')

  const ocultarTabla = React.useCallback(() => {
    setMostrarTabla(false)
  }, [])

  const clickVerSalidas = React.useCallback((id, idKardex) => {
    idTallerModalRef.current = id
    idKardexModalRef.current = idKardex
    setMostrarModalInformacion(true)
  }, [])

  const clickBuscar = React.useCallback(() => {
    if (tipoFiltro === TIPOSFILTROS.COSTO) {
      tableBaseParamsRef.current = { idCentroCostoNivel2 }
    } else {
      tableBaseParamsRef.current = { idServicio, idSubServicio1, idSubServicio2 }
    }

    setMostrarTabla(true)
  }, [tipoFiltro, idCentroCostoNivel2, idServicio, idSubServicio1, idSubServicio2])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Analisis De Reporte' />
        <Portlet.Body>
          <Row>
            <Col md={2}>
              <Form.Radio
                id='radio-costo'
                name='tipoFiltro'
                label='Por Centro Costo'
                value={TIPOSFILTROS.COSTO}
                checked={tipoFiltro === TIPOSFILTROS.COSTO}
                onChange={() => setTipoFiltro(TIPOSFILTROS.COSTO)}
              />
              <Form.Radio
                id='radio-servicios'
                name='tipoFiltro'
                label='Por Servicio y subServicios'
                value={TIPOSFILTROS.SERVICIO}
                checked={tipoFiltro === TIPOSFILTROS.SERVICIO}
                onChange={() => setTipoFiltro(TIPOSFILTROS.SERVICIO)}
              />
            </Col>
            <Col md={3} style={{ borderLeft: '1px solid black' }}>
              {tipoFiltro === TIPOSFILTROS.COSTO && (
                <Filtros.FiltroCosto
                  idCentroCostoNivel2={idCentroCostoNivel2}
                  setIdCentroCostoNivel2={setIdCentroCostoNivel2}
                  clickBuscar={clickBuscar}
                  ocultarTabla={ocultarTabla}
                />
              )}
              {tipoFiltro === TIPOSFILTROS.SERVICIO && (
                <Filtros.FiltroServicio
                  idServicio={idServicio}
                  setIdServicio={setIdServicio}
                  idSubServicio1={idSubServicio1}
                  setIdSubServicio1={setIdSubServicio1}
                  idSubServicio2={idSubServicio2}
                  setIdSubServicio2={setIdSubServicio2}
                  clickBuscar={clickBuscar}
                  ocultarTabla={ocultarTabla}
                />
              )}
            </Col>
          </Row>
          {mostrarTabla && (
            <>
              <Divider />
              <Row>
                <Col md={12}>
                  <Table.ServerSide
                    useNest={true}
                    url='/talleres'
                    headRows={tableHeaderRows}
                    baseParams={{
                      ...tableBaseParamsRef.current,
                      tipoConsulta: 'paginado-detalle-kardex'
                    }}
                    rowTemplate={row => (
                      <Table.Row key={row._id} hover>
                        <Table.Cell>{row.fechaIngreso || '--'}</Table.Cell>
                        <Table.Cell>{row.titulo || '--'}</Table.Cell>
                        <Table.Cell>{row.infoServicio || '--'}</Table.Cell>
                        <Table.Cell>{row.infoSubServicio1 || '--'}</Table.Cell>
                        <Table.Cell>{row.infoSubServicio2 || '--'}</Table.Cell>
                        <Table.Cell>{`${row.nombreProducto || '--'} - ${row.unidadMedida || '--'}`}</Table.Cell>
                        <Table.Cell>{row.cantidad || '--'}</Table.Cell>
                        <Table.Cell>
                          <Button tiny outline onClick={() => clickVerSalidas(row._id, row._idKardex)}>
                            Ver Detalle
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  />
                </Col>
              </Row>
            </>
          )}
        </Portlet.Body>
      </Portlet>
      {mostrarModalInformacion && (
        <Modals.InformacionTallerModal
          show={mostrarModalInformacion}
          handleClose={() => setMostrarModalInformacion(false)}
          idTaller={idTallerModalRef.current}
          idKardex={idKardexModalRef.current}
        />
      )}
    </>
  )
}

export default React.memo(AnalisisDeReporte)
